import { authHeader } from '@/_helpers'
export const targetSequencesService = {
  getSequencesByTarget,
  saveSequencesByTarget,
  getTargetSequences,
  getTargetSequencesType,
  savePromptSequenceType,
  regenerateByTarget,
  generateSequences,
}

const apiUrl = process.env.VUE_APP_ROOT_API

function regenerateByTarget(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  }
  return fetch(
    `${apiUrl}/targetsequences/generate-phrases`,
    requestOptions,
  ).then(handleResponse)
}

function getTargetSequencesType() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(
    `${apiUrl}/targetsequences/get-target-sequences-type`,
    requestOptions,
  ).then(handleResponse)
}

function savePromptSequenceType(id, prompt) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ id, prompt }),
  }
  return fetch(`${apiUrl}/targetsequences/save-prompt`, requestOptions).then(
    handleResponse,
  )
}

function getSequencesByTarget(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  }
  return fetch(
    `${apiUrl}/targetsequences/get-sequences-by-target`,
    requestOptions,
  ).then(handleResponse)
}

function saveSequencesByTarget(item) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ item }),
  }
  return fetch(`${apiUrl}/targetsequences/save`, requestOptions).then(
    handleResponse,
  )
}

function getTargetSequences(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(target_id),
  }
  return fetch(
    `${apiUrl}/targetsequences/get-target-sequences`,
    requestOptions,
  ).then(handleResponse)
}

function generateSequences(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(target_id),
  }
  return fetch(
    `${apiUrl}/targetsequences/generateSequences`,
    requestOptions,
  ).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = data || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
